<span
    class="{{ evaluateColumnExpression(column.cellClass, element) }} cdp-grid-cell-align-{{ column.cellAlignment }}"
    [title]="evaluateColumnExpression(column.tooltipText, element)"
>
    <span
        *ngIf="column.iconClass && column.cellAlignment !== 'right'"
        [class.is-disabled]="isDisabled"
        class="{{ evaluateColumnExpression(column.iconClass, element) }} icon-left"
    >
    </span>

    <ng-container [ngSwitch]="column.key">
        <span *ngSwitchCase="'tagList'">
            <div class="cdp-grid-chip-container">
                <hc-chip *ngFor="let tag of element.tagList" [tight]="true">
                    <span [innerHTML]="tag | highlight: searchTerm"></span>
                </hc-chip>
            </div>
        </span>

        <span *ngSwitchCase="'activeFlag'">
            <cdp-active-status-display
                [isActive]="element.activeFlag"
                [search]="searchTerm"
            ></cdp-active-status-display>
        </span>

        <span
            *ngSwitchDefault
            [innerHTML]="
                column.cellContentOverride
                    ? (evaluateColumnExpression(column.cellContentOverride, element)
                      | searchHighlight: searchTerm : 100)
                    : (element[column.key]?.toString() | searchHighlight: searchTerm : 100)
            "
            [class.is-disabled]="isDisabled && column.name !== 'priority'"
        ></span>
    </ng-container>
    <span
        *ngIf="column.iconClass && column.cellAlignment === 'right'"
        [class.is-disabled]="isDisabled"
        class="{{ evaluateColumnExpression(column.iconClass, element) }} icon-right"
    >
    </span>
</span>
